module.exports = __webpack_public_path__ + "media/img/description/galaxy-md-44a71f850a10e87c45a142aa11816c1c.svg";